export const PIN_USER = 'PIN_USER';
export const UNPIN_USER = 'UNPIN_USER';
